import { Component, OnInit } from '@angular/core';
import { ModalConfig } from '../../controls/modal/modal-config';
import { ModalRef } from '../../controls/modal/modal-ref';
import { Tab, TabColor } from '../../controls/tabs/tabs.component';

enum InstanceTab {
  OVERVIEW, MODULES
}

class InstanceProperty {
  key:string
  name:string;
}

@Component({
    selector: 'app-instance-details',
    templateUrl: './instance-details.component.html',
    styleUrls: ['./instance-details.component.css'],
    standalone: false
})
export class InstanceDetailsComponent implements OnInit {

  minheight:string;
  height:string = '400px';
  instanceMetaData:any;
  InstanceTab = InstanceTab;
  TabColor = TabColor;
  activeTab: InstanceTab = InstanceTab.OVERVIEW;
  overviewTab = new Tab('instance-overview-tab', $localize`Overview`, undefined, false);
  modulesTab = new Tab('instance-modules-tab', $localize`Modules`, undefined, false);
  tabs: Tab[] = [this.overviewTab, this.modulesTab];
  productName:string;
  supportHotfix:boolean;
  properties:InstanceProperty[] = [
    {key:'physicalAddress', name: $localize`Physical Address`},
    {key:'productId', name: $localize`Product Id`},
    {key:'productCode', name: $localize`Product Code`},
    {key:'productName', name: $localize`Product Name`},
    {key:'productVersion', name: $localize`Product Version`},
    {key:'manufacturer', name: $localize`Manufacturer`},
    {key:'installationDate', name: $localize`Installation Date`},
    {key:'installationTime', name: $localize`Installation Time`},
    {key:'timeZone', name: $localize`Time Zone`},
    {key:'installationDirectory', name: $localize`Installation Directory`},
    {key:'configurationDirectory', name: $localize`Configuration Directory`},
    {key:'logDirectory', name: $localize`Log Directory`},
    {key:'operatingSystem', name: $localize`Operating System`},
    {key:'patchLevel', name: $localize`Patch Level`},
    {key:'patchName', name: $localize`Patch Name`},
    {key:'patchFamily', name: $localize`Patch Family`},
    {key:'patchCode', name: $localize`Patch Code`},
    {key:'instanceURL', name: $localize`URL`},
    {key:'isMasterSystem', name: $localize`Primary system`},
  ];
  extraProperties:InstanceProperty[] = [
    {key:'patches', name: $localize`Installed patches`},
  ];

  constructor(private modalConfig: ModalConfig, private modalRef: ModalRef,) {
    this.instanceMetaData= this.modalConfig.data.instanceMetaData;
    this.productName= this.modalConfig.data.productName;
    this.supportHotfix = this.modalConfig.data.supportHotfix;
   }

  ngOnInit(): void {
  }

  getTitle():string{
    return $localize `${this.productName} instance details`;
  }

  onSelectedTabChange(selectedIndex: number) {
    this.activeTab = selectedIndex;
  }

  close():void {
    this.modalRef.close();
  }

}
